import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { InvoiceDetailsInterface } from '../types/invoice-details-interface'

interface useInvoiceDetailsInterface {
  invoiceId: number | null
}

export const useInvoiceDetails = ({ invoiceId }: useInvoiceDetailsInterface) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, InvoiceDetailsInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: invoiceDetails } = useControlledSwr(
    () => user && `/api/dashboard/affiliate-dashboard/purchase-invoice/${invoiceId}/status-details`,
    fetcher,
    undefined,
    !!user && !!invoiceId,
  )

  return { invoiceDetails }
}
